export function setPageTitle(title: string) {
	document.title = title ? `${title} – Parditka családfa` : `Parditka családfa`
}
